import { render, staticRenderFns } from "./SpE_Details.vue?vue&type=template&id=b98f908c"
import script from "./SpE_Details.vue?vue&type=script&lang=js"
export * from "./SpE_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports